export default __webpack_public_path__ + "static/media/momo01.9d2ade20.png";